import { Component, HostListener, OnInit, effect, inject, OnDestroy } from '@angular/core';
import { SharedSignalsService } from '../../common/services/shared-signals.service';

@Component({
  selector: 'taly-partner-signup',
  templateUrl: './partner-signup.component.html',
  styleUrls: ['./partner-signup.component.scss'],
  standalone: false,
})
export class PartnerSignupComponent implements OnInit, OnDestroy {
  transferSignal = inject(SharedSignalsService);
  isBanner: boolean = false;
  isThankyou: boolean = false;
  isError: boolean = false;
  textDirection: string;
  @HostListener('window:resize', ['$event'])
  onResize(event) {
    const deviceWidth = event.target.innerWidth; // Update device width on window resize
    this.showHeaderOnMobile(deviceWidth);
  }

  constructor() {
    const deviceWidth = window.innerWidth;
    this.showHeaderOnMobile(deviceWidth);
    effect(() => {
      this.isBanner = this.transferSignal?.showSignUpBanner();
      this.isThankyou = this.transferSignal?.showThankyouPopup();
      this.isError = this.transferSignal?.isError();
      this.textDirection = this.transferSignal.textDirection();
    });
  }

  ngOnInit(): void {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
  showHeaderOnMobile(deviceWidth: number) {
    if (deviceWidth < 768) {
      this.transferSignal.setHeader(true);
      this.transferSignal.headerType.set('site');
      this.transferSignal.setDarkHeader(true);
      this.transferSignal.setFooter(true);
    } else {
      this.transferSignal.setFooter(false);
      this.transferSignal.setHeader(false);
      this.transferSignal.headerType.set(undefined);
    }
  }
  tryAgain() {
    this.transferSignal.setShowSignUp(true);
    this.transferSignal.setErrorPopup(false);
    this.transferSignal.setShowThankyouPopup(false);
  }

  ngOnDestroy() {
    this.transferSignal.setFooter(true);
    this.transferSignal.setHeader(true);
    this.transferSignal.setShowSignUp(true);
    this.transferSignal.setShowThankyouPopup(false);
    this.transferSignal.setErrorPopup(false);
    this.transferSignal.headerType.set('site');
  }
}
